module.exports = __webpack_public_path__ + "static/media/portfolio-site.a1a30a8f.png";